import { appLocalStorage } from "@/utils";

const RESUME_SESSION_KEY = "cc.chat.session";

export type TResumeSession = {
  conversationId: string;
  resumeSecret: string;
};

const isSubprotocolSafeString = (value: unknown): value is string =>
  typeof value === "string" && /^[\w-]+$/.test(value);

const isValidResumeSession = (value: unknown): value is TResumeSession => {
  const v = value as Partial<TResumeSession> | null;
  return !!v && isSubprotocolSafeString(v.conversationId) && isSubprotocolSafeString(v.resumeSecret);
};

export const loadResumeSession = (): TResumeSession | null => {
  const stored = appLocalStorage.getItem<TResumeSession>(RESUME_SESSION_KEY);
  return isValidResumeSession(stored) ? stored : null;
};

export const saveResumeSession = (conversationId: string, resumeSecret: string): void => {
  if (!resumeSecret) return;
  appLocalStorage.setItem(RESUME_SESSION_KEY, { conversationId, resumeSecret });
};

export const clearResumeSession = (): void => {
  appLocalStorage.removeItem(RESUME_SESSION_KEY);
};
